module.exports = __webpack_public_path__ + "img/timbreTool-title.77b30838.png";